// Check if a value is Object id

export const isObjectId = (value) => {
  //   console.log(value);
  var checkForHexRegExp = new RegExp("^[0-9a-fA-F]{24}$");
  //   console.log(checkForHexRegExp.test(value));

  return checkForHexRegExp.test(value);
};
